<template>
  <div class="grey-card">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-alert
          effect="dark"
          @click="active(1)"
          :class="{ 'is-selected': isSelected === 1 }"
        >
          <div>
            <span>貨品名稱 :</span>
            <span>Adidas Y-3 波鞋</span>
          </div>
          <div>
            <span>連結 :</span>
            <span>http://123123213123123.com</span>
          </div>
          <div>
            <span>貨品品牌 :</span>
            <span>Adidas Y-3</span>
          </div>
          <div>
            <span>貨品類型 :</span>
            <span>服裝</span>
          </div>
          <div>
            <span>價錢 :</span>
            <span>320 USD</span>
          </div>
          <div>
            <span>貨品訂單編號 :</span>
            <span>1231241515</span>
          </div>
          <div>
            <span>貨品追踪號碼 :</span>
            <span>Adidas Y-3 </span>
          </div>
          <div>
            <span>數量 :</span>
            <span>1</span>
          </div>
          <div>
            <span>Repack :</span>
            <span>No</span>
          </div>
        </el-alert>
      </el-col>
      <el-col :span="12">
        <el-alert
          effect="dark"
          @click="active(2)"
          :class="{ 'is-selected': isSelected === 2 }"
        >
          <div>
            <span>貨品名稱 :</span>
            <span>Adidas Y-3 波鞋</span>
          </div>
          <div>
            <span>連結 :</span>
            <span>http://123123213123123.com</span>
          </div>
          <div>
            <span>貨品品牌 :</span>
            <span>Adidas Y-3</span>
          </div>
          <div>
            <span>貨品類型 :</span>
            <span>服裝</span>
          </div>
          <div>
            <span>價錢 :</span>
            <span>320 USD</span>
          </div>
          <div>
            <span>貨品訂單編號 :</span>
            <span>1231241515</span>
          </div>
          <div>
            <span>貨品追踪號碼 :</span>
            <span>Adidas Y-3 </span>
          </div>
          <div>
            <span>數量 :</span>
            <span>1</span>
          </div>
          <div>
            <span>Repack :</span>
            <span>No</span>
          </div>
        </el-alert>
      </el-col>
      <el-col :span="12">
        <el-alert
          effect="dark"
          @click="active(3)"
          :class="{ 'is-selected': isSelected === 3 }"
        >
          <div>
            <span>貨品名稱 :</span>
            <span>Adidas Y-3 波鞋</span>
          </div>
          <div>
            <span>連結 :</span>
            <span>http://123123213123123.com</span>
          </div>
          <div>
            <span>貨品品牌 :</span>
            <span>Adidas Y-3</span>
          </div>
          <div>
            <span>貨品類型 :</span>
            <span>服裝</span>
          </div>
          <div>
            <span>價錢 :</span>
            <span>320 USD</span>
          </div>
          <div>
            <span>貨品訂單編號 :</span>
            <span>1231241515</span>
          </div>
          <div>
            <span>貨品追踪號碼 :</span>
            <span>Adidas Y-3 </span>
          </div>
          <div>
            <span>數量 :</span>
            <span>1</span>
          </div>
          <div>
            <span>Repack :</span>
            <span>No</span>
          </div>
        </el-alert>
      </el-col>
      <el-col :span="12">
        <el-alert
          effect="dark"
          @click="active(4)"
          :class="{ 'is-selected': isSelected === 4 }"
        >
          <div>
            <span>貨品名稱 :</span>
            <span>Adidas Y-3 波鞋</span>
          </div>
          <div>
            <span>連結 :</span>
            <span>http://123123213123123.com</span>
          </div>
          <div>
            <span>貨品品牌 :</span>
            <span>Adidas Y-3</span>
          </div>
          <div>
            <span>貨品類型 :</span>
            <span>服裝</span>
          </div>
          <div>
            <span>價錢 :</span>
            <span>320 USD</span>
          </div>
          <div>
            <span>貨品訂單編號 :</span>
            <span>1231241515</span>
          </div>
          <div>
            <span>貨品追踪號碼 :</span>
            <span>Adidas Y-3 </span>
          </div>
          <div>
            <span>數量 :</span>
            <span>1</span>
          </div>
          <div>
            <span>Repack :</span>
            <span>No</span>
          </div>
        </el-alert>
      </el-col>
    </el-row>
  </div>
  <div class="center">
    <el-row>
      <el-col>
        <el-checkbox label="全選 (1)"></el-checkbox>
      </el-col>
      <el-col>
        <el-button type="primary">提交</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSelected: 1,
    };
  },
  methods: {
    active(option) {
      this.isSelected = option;
    },
  },
};
</script>

<style>
.grey-card {
  background-color: #f5f5f5;
  border-radius: 20px;
  padding: 20px 20px 80px 20px;
}

.grey-card .el-alert.el-alert--info {
  background-color: #fff;
  color: black;
  padding: 20px;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0px 3px 12px rgba(68, 13, 80, 0.1);
  border: 4px solid transparent;
  margin-bottom: 1rem;
}

.grey-card .el-alert.el-alert--info div {
  margin-bottom: 0.5rem;
}

.grey-card .el-alert.el-alert--info span {
  font-size: 15px;
}

.grey-card .el-alert.el-alert--info span:first-of-type {
  color: #333333;
}

.grey-card .el-alert.el-alert--info span:nth-of-type(2) {
  color: #782d88;
  margin-left: 0.5rem;
}

.grey-card .el-icon.el-alert__closebtn {
  color: #838383 !important;
  background-color: #f5f5f5;
  border-radius: 100%;
  width: 18px;
  height: 18px;
  /* margin-top: 20px; */
}

.grey-card .el-icon.el-alert__closebtn svg {
  height: 100%;
}

.grey-card .el-alert.el-alert--info.is-selected {
  border-color: #782d88;
}

.grey-card + .center {
  text-align: center;
}

.grey-card + .center .el-checkbox {
  margin-top: 0.5rem;
}

.grey-card + .center .el-button {
  border-radius: 8px;
  background-color: #7a3d87;
  border-color: #7a3d87;
  width: 20%;
}

.grey-card + .center .el-button:hover {
  background-color: #793d87d2;
}
</style>